class QuickBuy extends HTMLElement {
  constructor() {
    super();

    this.sectionId = "quick-buy";

    this.els = {
      body: this.querySelector('[data-quick-buy-el="body"]'),
      close: this.querySelectorAll('[data-quick-buy-el="close"]'),
    };

    this.externalEls = {
      modal: document.querySelector('[data-quick-buy-external-el="modal"]'),
      close: document.querySelectorAll('[data-quick-buy-external-el="close"]'),
    };

    this.setupListeners();
  }

  setupListeners() {
    this.handleTrigger = this.handleTrigger.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handleFormSubmit = this.handleFormSubmit.bind(this);

    document.addEventListener("click", this.handleTrigger);
    document.addEventListener("touchstart", this.handleTrigger);

    this.els?.close.forEach((closeEl) => {
      closeEl.addEventListener("click", this.handleClose);
    });

    this.externalEls?.close.forEach((closeEl) => {
      closeEl.addEventListener("click", this.handleClose);
    });

    document.addEventListener("click", this.handleFormSubmit);

    window.addEventListener("resize", this.handleResize.bind(this));
  }

  async handleTrigger(event) {
    const trigger = event.target.closest(
      '[data-quick-buy-external-el="trigger"]',
    );

    if (!trigger) return;

    let productUrl = trigger.dataset.producturl;

    if (productUrl.charAt(0) === "/") {
      productUrl = `${window.location.origin}${productUrl}`;
    }

    try {
      const response = await fetch(
        `${productUrl}?section_id=${this.sectionId}`,
      );

      if (!response.ok) throw new Error("Network response was not ok");

      const sectionHTML = await response.text();
      this.els.body.innerHTML = sectionHTML;

      this.setPrivateSaleInput();

      document.body.classList.add("util-SiteOverflowed");
      this.externalEls.modal.showModal();
    } catch (error) {
      this.close();
    }
  }

  setPrivateSaleInput() {
    const form = this.querySelector('form[data-quick-buy-card-el="form"]');

    if (!form) return;

    if (
      form.dataset.privateSale === "true" &&
      (window.privateSale || window.initialPrivateSaleAccess)
    ) {
      const input = document.createElement("input");
      input.type = "hidden";
      input.name = "properties[PrivateSale]";
      input.value = window.privateSaleType;
      input.classList.add("custom-sale-type");
      form.appendChild(input);
    }
  }

  handleFormSubmit(event) {
    const trigger = event.target.closest('[data-quick-buy-card-el="submit"]');

    if (!trigger) return;

    this.handleClose();
  }

  handleResize() {
    if (window.innerWidth > 750) {
      this.handleClose();
    }
  }

  handleClose() {
    document.body.classList.remove("util-SiteOverflowed");
    this.externalEls.modal.close();
  }
}

if (!customElements.get("quick-buy")) {
  customElements.define("quick-buy", QuickBuy);
}
